import React from "react"

import Icon from "icons"
import RatingByLine from "components/common/rating-by-line"
import GeneralCard from "../base"
import { SupplementsShortIcon, SupplementsCategory, SupplementsLogo, BottomRight } from "./styles"

const SupplementsCard = ({ inline, category, rating, ...props }) => (
  <GeneralCard
    {...props}
    topLeftElement={
      inline ? <SupplementsLogo /> : <SupplementsCategory>{category}</SupplementsCategory>
    }
    topRightElement={<SupplementsShortIcon id="shop-icon" width={16} height={16} />}
    bylineElement={inline && rating && <RatingByLine rating={rating} />}
    bottomRightElement={
      inline && (
        <BottomRight>
          <Icon id="shop-icon" width={15} />
        </BottomRight>
      )
    }
  />
)

export default SupplementsCard
